export const DeleteIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={30}
    fill="none"
    {...props}
  >
    <path
      fill="#FF0004"
      d="M4.25 13.458c0 .78.638 1.417 1.417 1.417h5.666a1.42 1.42 0 0 0 1.417-1.417v-8.5h-8.5v8.5Zm9.208-10.625H10.98l-.708-.708H6.729l-.708.708H3.54V4.25h9.917V2.833Z"
    />
  </svg>
);
